import { Component, OnInit, forwardRef } from "@angular/core";
import {
  ModalController,
  NavController,
  LoadingController,
  NavParams,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AnotacaoEditPage } from "./anotacao-edit/anotacao-edit.page";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { Share } from "@capacitor/share";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";

@Component({
  selector: "app-anotacao-list",
  templateUrl: "./anotacao-list.page.html",
  styleUrls: ["./anotacao-list.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    LoadingSpinnerComponent,
    SemRegistroComponent
  ],
})
export class AnotacaoListPage implements OnInit {
  id: any = "";
  anotacoes: any = [];
  loaded = false;

  constructor(
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    private translate: TranslateService,
    public loadingController: LoadingController,
    public userProvider: UserProvider,
    public navParams: NavParams,
    public pessoaProvider: PessoaProvider
  ) {
    this.pessoaProvider.getAnotacao().subscribe({
      next: (data) => {
        this.anotacoes = data;

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro ao buscar a Anotação:", err);
        this.loaded = true;
      },
    });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async share(anotacao: { entidade: string; anotacao: string }) {
    await Share.share({
      text:
        "Minha Anotação - " +
        anotacao.entidade +
        " - " +
        anotacao.anotacao +
        "",
    });
  }

  async editAnotacao(anotacao: {
    id: any;
    anotacao: string;
    entidade: string;
  }) {
    let data = {
      id: anotacao.id,
      anotacao: anotacao.anotacao,
      entidade: anotacao.entidade,
    };
    const modalPage = await this.modalCtrl.create({
      component: AnotacaoEditPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onDidDismiss()).data;
    this.pessoaProvider.getAnotacao().subscribe((data) => {
      this.anotacoes = data;
    });
  }
}
